import { render } from "./ViewUpdateModal.vue?vue&type=template&id=35dbfb8c&scoped=true&ts=true"
import script from "./ViewUpdateModal.vue?vue&type=script&lang=ts"
export * from "./ViewUpdateModal.vue?vue&type=script&lang=ts"

import "./ViewUpdateModal.vue?vue&type=style&index=0&id=35dbfb8c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dbfb8c"]])

export default __exports__